import { MenuItem, Typography } from "@mui/material";
import { Skeleton } from "@mui/material";
import { MultiselectDropdown } from "components/MultiselectDropdown";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { SeverityTypeContext } from "contexts/SeverityTypeContext";
import { SeverityType } from "core/enums";

export function SeverityDropdown({
  value,
  onChange,
  showUnassigned = false,
  ...rest
}) {
  const { loading, error, alertSeverityTypes: severityTypes } = useContext(
    SeverityTypeContext
  );

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height={56} />;
  }

  if (error) {
    return <Typography>An error occured</Typography>;
  }

  return (
    <MultiselectDropdown
      value={value}
      onChange={e => onChange(e.target.value)}
      label="Severity"
      labelId="alerts-severity-filter"
      {...rest}
    >
      {severityTypes?.map(({ id, name }) => {
        if (!showUnassigned && id === SeverityType.UNASSIGNED) {
          return null;
        }

        return (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        );
      }) ?? []}
    </MultiselectDropdown>
  );
}

SeverityDropdown.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  onChange: PropTypes.func,
  showUnassigned: PropTypes.bool
};
